

import { CloudAuthSitePage } from './site.cloud';
import { DemoAuthSitePage } from './site.demo';

import { mixin } from '@cems-eco/core/src/utils/platform';
import environment from "@/config";

export default class Site extends mixin(environment.nexus, {
  box: CloudAuthSitePage,
  cloud: CloudAuthSitePage,
  demo: DemoAuthSitePage
}){}
